import {
  APP_INITIALIZER,
  ApplicationConfig,
  importProvidersFrom,
} from '@angular/core';
import { provideRouter, withRouterConfig } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideMomentDateAdapter } from '@angular/material-moment-adapter';

import { routes } from './app.routes';
import { HttpClientModule, provideHttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { from } from 'rxjs';
import { graphqlProvider } from './graphql.provider';
import { provideNativeDateAdapter } from '@angular/material/core';
import { AppInitializer } from './appInitializer.component';
import { provideQuillConfig } from 'ngx-quill/config';

import Quill from 'quill';

export function initializeApp(appInitializer: AppInitializer) {
  return () => appInitializer.initialize();
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      routes,
      withRouterConfig({ paramsInheritanceStrategy: 'always' })
    ),
    provideAnimations(),
    importProvidersFrom(
      HttpClientModule,
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: () => {
            return {
              getTranslation(lang: string) {
                return from(import(`../assets/i18n/${lang}.json`));
              },
            };
          },
        },
        defaultLanguage: 'en-EN',
      })
    ),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppInitializer],
      multi: true,
    },
    provideMomentDateAdapter(),
    provideHttpClient(),
    graphqlProvider,
    provideNativeDateAdapter(),
    provideQuillConfig({
      modules: {
        syntax: false,
        toolbar: [
          ['bold', 'italic', 'underline', 'strike'], // toggled buttons
          ['blockquote', 'code-block'],
          [{ header: 1 }, { header: 2 }], // custom button values
          [{ list: 'ordered' }, { list: 'bullet' }],
          [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
          [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
          [{ direction: 'rtl' }], // text direction
          [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          [{ color: [] }, { background: [] }], // dropdown with defaults from theme
          [{ font: ['ABBVoice', 'sansserif', 'serif', 'monospace'] }],
          [{ align: [] }],
          ['clean'], // remove formatting button
          ['link', 'image', 'video'], // link and image, video
        ],
      },
      customOptions: [{
        import: 'formats/font',
        whitelist: ['ABBVoice', 'sansserif', 'serif', 'monospace'],
      }]
    }),
  ],
};
